const FAQ_ITEMS = [
    {
        question: 'What is Luckynote?',
        answer: 'Luckynote is a productivity app that works like a chat: you message yourself notes, links, files, and tasks in one inbox, then search and organize everything later. It is built for people who already text themselves things to remember, but find that thread impossible to use over time. Luckynote is the version that does not get buried.'
    },
    {
        question: 'How does Luckynote compare to other productivity apps?',
        answer: "Most productivity apps ask you to organize before you save: pick a notebook, a tag, a folder. Luckynote flips that: save anything instantly like a text message, then search or organize when you are ready. If you never organize, smart search finds what you need by content type, keyword, or date. Save now, find later."
    },
    {
        question: 'Is Luckynote a second brain app?',
        answer: "Yes, but without the setup overhead. Most second brain tools require a system before they become useful. Luckynote works on day one: capture everything into one inbox, then use full-text search, folders, and stars to retrieve anything as your system takes shape. The chat-style flow keeps it fast enough that you actually use it, and it syncs across all your devices."
    },
    {
        question: 'What makes Luckynote special?',
        answer: 'Luckynote combines instant capture with reliable retrieval. You save anything (a link, a photo, a task, a file) in seconds, without deciding where it goes. Later, full-text search, type filters, folders, and starred notes let you find it. You should not have to feel lucky when you find something you saved. With Luckynote, you can feel lucky every day.'
    },
    {
        question: 'How does Luckynote handle encryption and privacy?',
        answer: "Everything you send to and from Luckynote travels over a secure, encrypted connection, and your password is never stored in a way anyone, including us, could read it back. Your notes, files, and account data are stored securely and encrypted, both while saved and while being transferred. We don't offer full end-to-end encryption today, since that would break search and syncing across your devices, but if that's something you need, let us know. We never sell your information to third parties, and you can delete your data at any time. Full details are on our Data Security page."
    },
    {
        question: 'How does the free version work?',
        answer: "The free version includes unlimited folders, sync across all devices, and our Look Up feature for quick searches. It is designed to be fully usable from day one: no time limit, no feature wall for the core experience."
    },
    {
        question: 'Can I access my notes offline?',
        answer: "You can create messages while offline and they will sync when you reconnect. Messages in your Stars and Tasks folders are cached for offline access, so your most important notes are always available."
    },
    {
        question: 'Can I search text inside my screenshots?',
        answer: 'Yes. Luckynote reads text in images, so a screenshot of a recipe or pricing page is findable by what it says.'
    },
    {
        question: 'Can I save voice notes and find them later?',
        answer: 'Yes. Voice notes are transcribed in Luckynote and stay searchable like typed notes.'
    },
    {
        question: 'How do I save things from Instagram, TikTok, or the web?',
        answer: 'Share to Luckynote from any app on your phone, save a screenshot, or use the web extension on desktop. For social posts, Luckynote saves the link and its preview plus any screenshots you take, while the original post stays on the original platform.'
    },
    {
        question: 'Can I export my data?',
        answer: "Yes. From Settings, you can export your entire account at any time, folders, notes, highlights, and saved links included. We package it up and email you a download link. There's no lock-in: if you ever want to leave, you can take everything with you."
    }
];

module.exports = {
    FAQ_ITEMS
};
